import type { ReactNode } from 'react';
import React from 'react';

import { FlagsProvider } from '@atlaskit/flag/flags-provider';

import { ProfileCardWrapper } from '@confluence/profile/entry-points/ProfileCardWrapper.ts';

import { toUsableIdentityAccountId } from './toUsableIdentityAccountId.ts';

export type AnalyticsProfileIdentityProps = {
	userId?: string | null;
	fullName?: string;
	children: ReactNode;
	agent?: Record<string, never>;
	position?: 'bottom-start' | 'left-start';
	offset?: [number, number];
};

export const AnalyticsProfileIdentity = ({
	userId,
	fullName,
	children,
	agent,
	position = 'bottom-start',
	offset = [0, 8],
}: AnalyticsProfileIdentityProps): React.JSX.Element => {
	const usableUserId = toUsableIdentityAccountId(userId);
	if (!usableUserId) {
		return <>{children}</>;
	}

	const card = (
		<ProfileCardWrapper
			userId={usableUserId}
			fullName={fullName}
			trigger="click"
			position={position}
			offset={offset}
			{...(agent ? { agent } : {})}
		>
			{children}
		</ProfileCardWrapper>
	);

	if (agent) {
		return <FlagsProvider>{card}</FlagsProvider>;
	}

	return card;
};
